import CylinderSpinLoader from './CylinderSpinLoader'

export default CylinderSpinLoader
